export const shouldUpdateFundInvestmentSheetNames = (
  currentNames: string[],
  incomingNames: string[]
) =>
  currentNames.length !== incomingNames.length || currentNames.some((name, index) => name !== incomingNames[index]);
